import React from 'react'

import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

import { ROLE_USER_MANAGEMENT_ADMIN_ONLY, ROLE_STANDARD_ACCESS } from 'utils/authority'



export const publicRoutes = [

    {

        key: 'login',

        path: `${AUTH_PREFIX_PATH}/login`,

        component: React.lazy(() => import('views/auth-views/authentication/login')),

    },

    {

        key: 'login-1',

        path: `${AUTH_PREFIX_PATH}/login-1`,

        component: React.lazy(() => import('views/auth-views/authentication/login-1')),

    },

    {

        key: 'error-page-1',

        path: `${AUTH_PREFIX_PATH}/error-page-1`,

        component: React.lazy(() => import('views/auth-views/errors/error-page-1')),

    },

]



export const protectedRoutes = [

    {

        key: 'account',

        path: `/account`,

        component: React.lazy(() => import('views/app-views/account/MyAccount')),

    },

    {

        key: 'home',

        path: `/home`,

        component: React.lazy(() => import('views/app-views/dashboards/')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'listReport',

        path: `/home/list-reports`,

        component: React.lazy(() => import('views/app-views/dashboards/')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'changePassword',

        path: `/admin/change-password`,

        component: React.lazy(() => import('views/app-views/admin/ChangePasword')),

    },

    {

        key: 'admin',

        path: `/admin/timezone`,

        component: React.lazy(() => import('views/app-views/admin/timezone')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'admin.timezone',

        path: `/admin/timezone`,

        component: React.lazy(() => import('views/app-views/admin/timezone')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'admin.services.phoneNumbers',

        path: `/admin/phone-number-services`,

        component: React.lazy(() => import('views/app-views/admin/services/phoneNumberServices')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'report.campaign',

        path: `/report/campaign`,

        component: React.lazy(() => import('views/app-views/reports/campaignReport')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'report.campaign.sms',

        path: `/report/campaign/sms/:campaignDetailsID`,

        component: React.lazy(() => import('views/app-views/reports/campaignReport/SmsCampaignReport')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'report.campaign.chart',

        path: `/report/campaign/chart/:campaignDetailsID`,

        component: React.lazy(() => import('views/app-views/reports/campaignReport/SmsCampaignChartReport')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'report.contactlistreport',

        path: `/report/contact-list-report`,

        component: React.lazy(() => import('views/app-views/reports/contactlistReport')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'report.contactlistdetails',

        path: `/report/contact-list-report/details/:contactListId`,

        component: React.lazy(() => import('views/app-views/reports/contactlistReport/ContactDetails')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'report.smstemplatereport',

        path: `/report/sms-template-report`,

        component: React.lazy(() => import('views/app-views/reports/smstemplateReport')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'report.userreport',

        path: `/report/user-report`,

        component: React.lazy(() => import('views/app-views/reports/userReport')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'report.quickTestReport',

        path: `/report/quick-test-report`,

        component: React.lazy(() => import('views/app-views/reports/quickTestReport')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'report.userActionLogReport',

        path: `/report/user-action-log-report`,

        component: React.lazy(() => import('views/app-views/reports/userActionLogReport')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'resource',

        path: `/resource`,

        component: React.lazy(() => import('views/app-views/resource')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'resource.contacts',

        path: `/resource/contact-services/:contactListID`,

        component: React.lazy(() => import('views/app-views/resource/contactServices')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'admin.campaigns',

        path: `${APP_PREFIX_PATH}/campaigns/campaign`,

        component: React.lazy(() => import('views/app-views/campaigns/Campaign')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'admin.campaign.sms',

        path: `${APP_PREFIX_PATH}/campaign/sms/:campaignDetailsID/:name`,

        component: React.lazy(() => import('views/app-views/campaigns/viewSms')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'admin.campaigns.action',

        path: `${APP_PREFIX_PATH}/campaigns/campaign/action`,

        component: React.lazy(() => import('views/app-views/campaigns/ActionTable')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

    {

        key: 'admin.users',

        path: `/admin/users`, 

        component: React.lazy(() => import('views/app-views/admin/users')),

        meta: { roles: ROLE_USER_MANAGEMENT_ADMIN_ONLY },

    },    

    {

        key: 'admin.userRoles',

        path: `/admin/user-roles`, 

        component: React.lazy(() => import('views/app-views/admin/userRoles')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },    

    {

        key: 'admin.sms',

        path: `/admin/sms-templates`,  

        component: React.lazy(() => import('views/app-views/admin/sms')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    }, 

    {

        key: 'admin.twilioConfig',

        path: `/admin/telephony-config`,   

        component: React.lazy(() => import('views/app-views/admin/twilioConfig')),

        meta: { roles: ROLE_STANDARD_ACCESS },

    },

]


